export default "__VITE_ASSET__C_j5segH__"